import _ from 'lodash';

import { CommandStatusEnum } from './CommandStatusEnum';

const DEFAULT_STATUS = _.sortBy([
  CommandStatusEnum.CommandReceivedAndUpdated,
  CommandStatusEnum.CommandWaitingForDeliver,
]);

export default class GetCommandsHistoryFilter {
  status: CommandStatusEnum[] = [...DEFAULT_STATUS];

  indicatorName: string[] = [];

  before: Date = null;

  isDefaultStatus = () => {
    return _.isEqual(_.sortBy(this.status), DEFAULT_STATUS);
  };
}
